import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  preview: {
    boxSizing: 'border-box',
    border: '1px solid black',
    position: 'absolute',
  },
});

const RestPreview = ({
  classes, x, y, width, height, zoom,
}) => (
  <div
    className={classes.preview}
    style={{
      top: y * zoom,
      left: x * zoom,
      height: `${(height || 0) * zoom}px`,
      width: `${(width || 0) * zoom}px`,
    }}
  />
);

export default withStyles(styles)(RestPreview);
